import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FooterAbstracClassComponent } from '../../shared/footer-abstrac-class.component';
import { additinalMenu } from '@shared/configs/additional-menu';
import { MenuItem } from '@shared/models/menu-item.model';
import { RowHeaderComponent } from '../../shared/row-header/row-header.component';
import { FooterMenuItemComponent } from '../../shared/footer-menu-item/footer-menu-item.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-additional-info',
    templateUrl: './additional-info.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RowHeaderComponent, FooterMenuItemComponent, TranslatePipe],
})
export class AdditionalInfoComponent extends FooterAbstracClassComponent {
    additionalMenu: MenuItem[] = additinalMenu;
}
